<div
  class="ui-card-glass-shell"
  [ngClass]="[computedClasses, shellPaddingClasses]"
  [style.backdrop-filter]="inlineBackdropFilter"
  [style.webkitBackdropFilter]="inlineBackdropFilter">
  <!-- Glassmorphism overlay effects -->
  <div class="absolute inset-0 rounded-xl pointer-events-none">
    <!-- Light mode gradient overlay -->
    <div
      class="absolute inset-0 pointer-events-none bg-linear-to-br from-white/12 via-blue-50/4 to-blue-200/8 opacity-40 dark:opacity-0">
    </div>

    <!-- Dark mode gradient overlay -->
    <div
      class="absolute inset-0 pointer-events-none bg-linear-to-br from-blue-300/5 via-transparent to-blue-500/12 opacity-0 dark:opacity-58">
    </div>

    <!-- Animated border glow -->
    <div class="absolute inset-0 rounded-xl pointer-events-none opacity-0 hover:opacity-100 transition-opacity duration-500
                    bg-linear-to-r from-transparent via-primary-400/20 to-transparent
                    dark:via-primary-300/30 animate-glass-shimmer"></div>
  </div>

  <!-- Content container -->
  <div class="relative z-10 h-full flex flex-col">
    <!-- Card Header -->
    @if (hasHeader) {
    <div
      class="card-glass-header border-b border-blue-200/24 px-4 py-3 sm:px-5 sm:py-4 lg:px-6 bg-linear-to-b from-slate-100/72 to-white/48 dark:from-slate-800/88 dark:to-slate-950/80 dark:border-blue-200/14 rounded-t-xl">
      <div class="relative z-10">
        <ng-content select="[slot=header]"></ng-content>
      </div>
      <!-- Header glass accent -->
      <div
        class="absolute inset-0 pointer-events-none bg-linear-to-r from-blue-200/10 dark:from-blue-500/18 to-transparent opacity-70 rounded-t-xl">
      </div>
    </div>
    }

    <!-- Card Content -->
    <div class="card-glass-content flex-1 relative" [ngClass]="contentClasses">
      <div class="card-glass-projected-content relative z-10">
        <!-- Slotted content takes priority -->
        <ng-content select="[slot=content]"></ng-content>
        <!-- Fallback for non-slotted content (only shows if no slotted content) -->
        <ng-content></ng-content>
      </div>
    </div>

    <!-- Card Footer -->
    @if (hasFooter) {
    <div
      class="card-glass-footer border-t border-blue-200/24 px-4 py-3 sm:px-5 sm:py-4 lg:px-6 bg-linear-to-b from-white/48 to-slate-100/68 dark:from-slate-900/76 dark:to-slate-950/90 dark:border-blue-200/14 rounded-b-xl">
      <div class="relative z-10">
        <ng-content select="[slot=footer]"></ng-content>
      </div>
      <div
        class="absolute inset-0 pointer-events-none bg-linear-to-l from-blue-200/8 dark:from-blue-500/14 to-transparent opacity-65 rounded-b-xl">
      </div>
    </div>
    }
  </div>

  <!-- Floating glass particles effect (for product cards) -->
  @if (variant === 'product') {
  <div
    class="absolute inset-0 overflow-hidden pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity duration-700">
    <div class="absolute top-1/4 left-1/4 w-2 h-2 bg-primary-400/30 rounded-full animate-float"></div>
    <div class="absolute top-3/4 right-1/4 w-1 h-1 bg-primary-300/40 rounded-full animate-float-delayed"></div>
    <div class="absolute top-1/2 right-1/3 w-1.5 h-1.5 bg-white/20 rounded-full animate-float-slow"></div>
  </div>
  }
</div>
